<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <v-form ref="bankAccountForm" @submit.prevent="saveBankAccount" class="custom-form">
                    <v-card :elevation="1" color="blue lighten-5">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-toolbar color="#546E7A" dark :elevation="1" height="30px">
                                    <v-toolbar-title class="subtitle-2">Bank Account Information</v-toolbar-title>
                                </v-toolbar>
                                <v-card-text class="py-0 mt-1">
                                    <v-row dense justify="center">
                                        <v-col cols="4">
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="3">Acct. Name</v-col>
                                                <v-col cols="9">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        :rules="[v => !!v]"
                                                        v-model="account.account_name"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="3">Acct. No</v-col>
                                                <v-col cols="9">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        :rules="[v => !!v]"
                                                        v-model="account.account_number"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="3">Acct. Type</v-col>
                                                <v-col cols="9">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        :rules="[v => !!v]"
                                                        v-model="account.account_type"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="3">Bank Name</v-col>
                                                <v-col cols="9">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        :rules="[v => !!v]"
                                                        v-model="account.bank_name"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="4" class="text-right pr-2">Branch Name</v-col>
                                                <v-col cols="7">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        v-model="account.branch_name"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="4" class="text-right pr-2">Initial Balance</v-col>
                                                <v-col cols="7">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        v-model.number="account.initial_balance"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="4" class="text-right pr-2">Description</v-col>
                                                <v-col cols="7">
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        hide-details
                                                        height="8vh"
                                                        v-model="account.description"
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col cols="4"></v-col>
                                                <v-col cols="7">
                                                    <v-row no-gutters>
                                                         <v-col cols="6" class="pr-1">
                                                            <v-btn @click="resetForm" height="30px" dark block color="deep-orange">Clear</v-btn>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-btn type="submit" :loading="waitingForSave" height="30px" dark block color="light-blue darken-2">Save</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
        <v-row dense class="mt-1">
            <v-col cols="12" class="pb-0">
                <v-data-table
                    class="custom-data-table elevation-1"
                    dense
                    :headers="accountHeaders"
                    :loading="$store.getters['bankAccount/loading']"
                    :items="$store.getters['bankAccount/bankAccounts']"
                    :search="searchBankAccounts"
                >
                    <template v-slot:top>
                        <v-toolbar dense color="white" :elevation="1" height="30px">
                            <v-toolbar-title class="subtitle-2">Bank Account List</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-form class="custom-form">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    placeholder="Search Transaction"
                                    append-icon="mdi-magnify"
                                    style="width:300px;"
                                    v-model="searchBankAccounts"
                                >
                                </v-text-field>
                            </v-form>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <span v-if="item.status">Active</span>
                        <span v-if="!item.status">Inactive</span>
                    </template>
                    <template v-if="userType != 'user'" v-slot:[`item.action`]="{ item }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-icon small @click="editBankAccount(item)" color="primary" v-on="on">mdi-circle-edit-outline</v-icon>
							</template>
							<span>Edit</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-icon small @click="openDeleteDialog(item.id)" color="error" v-on="on" >mdi-delete-circle-outline</v-icon>
							</template>
							<span>Delete</span>
						</v-tooltip>
					</template>
                </v-data-table>
            </v-col>
        </v-row>

        <delete-confirm ref="deleteDialog" @confirm="deleteBankAccount"></delete-confirm>

    </v-container>
</template>

<script>
import DeleteConfirm from '@/components/Confirm'

export default {
    name: 'CashTransaction',
    components: {
        DeleteConfirm,
    },
    data: ()=> ({
        date: new Date().toISOString().substr(0, 10),
        accountHeaders: [
            { text: 'Account Name', value: 'account_name' },
            { text: 'Account Number', value: 'account_number' },
            { text: 'Account Type', value: 'account_type' },
            { text: 'Bank Name', value: 'bank_name' },
            { text: 'Branch Name', value: 'branch_name' },
            { text: 'Initial Balance', value: 'initial_balance' },
            { text: 'Status', value: 'status' },
            { text: 'Action', value: 'action' },
        ],
        searchBankAccounts: '',
        account: {
            account_name: '',
            account_number: '',
            account_type: '',
            bank_name: '',
            branch_name: '',
            initial_balance: 0,
            description: '',
        },
        waitingForSave: false,
        bankAccountEditId: null,
        bankAccountDeleteId: null,
        userType: ''
    }),
    created() {
        this.$store.dispatch('bankAccount/getBankAccounts')
        let userData = JSON.parse(localStorage.getItem('_userData'))
        this.userType = userData.user_type 
    },
    methods: {
        async saveBankAccount() {
            if (!this.$refs.bankAccountForm.validate()) return
            this.waitingForSave = true
            if (this.bankAccountEditId == null) {
                let res = await this.$store.dispatch('bankAccount/saveBankAccount', {
                    url: 'add-bank-account',
                    data: this.account
                })
                if (res) this.resetForm()
            } else {
                let res = await this.$store.dispatch('bankAccount/saveBankAccount', {
                    url: 'update-bank-account',
                    data: {...this.account, id: this.bankAccountEditId}
                })
                if (res) this.resetForm()
            }
            this.waitingForSave = false
        },

        editBankAccount(item) {
            this.bankAccountEditId = item.id
            Object.keys(this.account).map(k => this.account[k] = item[k])
        },

        openDeleteDialog(id) {
            this.bankAccountDeleteId = id
            this.$refs.deleteDialog.dialog = true
        },

        deleteBankAccount() {
            this.$store.dispatch('bankAccount/deleteBankAccount', {id: this.bankAccountDeleteId})
            this.$refs.deleteDialog.dialog = false
            this.bankAccountDeleteId = null
        },

        resetForm() {
            Object.keys(this.account).map(k => {
                if (k == 'initial_balance') this.account[k] = 0
                else this.account[k] = ''
            })
            this.bankAccountEditId = null
            this.$refs.bankAccountForm.resetValidation()
        }
    }
}
</script>

<style lang="scss" scoped>
    .v-icon.v-icon {
       font-size: 18px !important;
       top: 0 !important;
    }
    .v-icon.v-icon[data-v-1f38b4e5] {
        font-size: 14px !important;
        top: 0px !important; 
    }
    .v-messages {
        flex: 1 1 auto;
        font-size: 12px;
        min-height: 0px !important;
        max-height: 0px!important;
        min-width: 1px;
        position: relative;
    }
</style>